import ConfigUtils from './ConfigUtils';
export default class SocketUtils {
    static getSocketMessageTypes = () => Object.keys(ConfigUtils.getSocketMessages());

    static buildSocketMessage(type) {
        if (!SocketUtils.getSocketMessageTypes().includes(type)) {
            console.log(`Message type ${type} is not supported.`);
            return null;
        }
        return { type };
    };

    static isDashboardRefresh(message) {
        return message === 'DASHBOARD_REFRESH';
    };

    static isDashboardAndSummaryRefresh(message) {
        return message === 'DASHBOARD_AND_SUMMARY_REFRESH';
    };

    static isDashboardOrSummaryRefresh(message) {
        return message === 'DASHBOARD_REFRESH' || message === 'DASHBOARD_AND_SUMMARY_REFRESH';
    };
};